import * as React from 'react';
import { Button, Modal } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { pushSizeGuideLinkClickEvent, pushBookAppointmentClickEvent, pushVTOClickEvent } from '../../../Analytics/events/SizeGuideEvents.js';
import FindOutSize from './components/FindOutSize/FindOutSize.js';
import Measure from './components/Measure/Measure.js';
import SizeGuide from './components/SizeGuide/SizeGuide.js';

const SizeGuideModalView = ({ sizeGuideContent , productName , sku , isVtoEnabled ,  })=>{
    const { getLabel  } = useIntl();
    const [openModal, setOpenModal] = React.useState(false);
    if (!sizeGuideContent) {
        return null;
    }
    const { findOutSizeCTA , findOutSizeDescription , findOutSizeImage , findOutSizeSubtitle , findOutSizeTitle , measureDescription , measureDescriptionImage , measureImage , measureSteps , measureTitle , sizeGuideSizeCompound , sizeTitle ,  } = sizeGuideContent;
    const showVTOButton = !findOutSizeCTA && isVtoEnabled;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "size-guide-modal"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "size-guide-modal__title"
    }, getLabel('products.frameSize.title')), /*#__PURE__*/ React.createElement(Button, {
        className: "size-guide-modal__trigger",
        variant: "ghost",
        size: "custom",
        caption: getLabel('products.frameSize.link'),
        onClick: ()=>{
            setOpenModal(true);
            pushSizeGuideLinkClickEvent(sku, productName);
        }
    })), openModal && /*#__PURE__*/ React.createElement(Modal, {
        className: "size-guide-modal__modal",
        title: sizeTitle,
        isOpen: openModal,
        showIcon: true,
        onModalClose: ()=>setOpenModal(false)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "size-guide-modal__modal-container"
    }, /*#__PURE__*/ React.createElement(SizeGuide, {
        sizeGuideSizeCompound: sizeGuideSizeCompound
    }), /*#__PURE__*/ React.createElement(Measure, {
        measureDescription: measureDescription,
        measureDescriptionImage: measureDescriptionImage,
        measureImage: measureImage,
        measureSteps: measureSteps,
        measureTitle: measureTitle
    }), /*#__PURE__*/ React.createElement(FindOutSize, {
        findOutSizeCTA: findOutSizeCTA,
        findOutSizeDescription: findOutSizeDescription,
        findOutSizeImage: findOutSizeImage,
        findOutSizeSubtitle: findOutSizeSubtitle,
        findOutSizeTitle: findOutSizeTitle,
        showVTOButton: showVTOButton,
        onVTOStart: ()=>setOpenModal(false)
        ,
        pushBookAppointmentClickEvent: ()=>pushBookAppointmentClickEvent(sku, productName)
        ,
        pushVTOClickEvent: ()=>pushVTOClickEvent(sku, productName)
    }))));
};

export { SizeGuideModalView };
//# sourceMappingURL=SizeGuideModalView.js.map
